module.exports = __webpack_public_path__ + "static/media/projectInvestigacion.db8c7a5e.png";